import { HD, FULL_HD } from '@bedrock-rdk/constants';
import { FONT, FONT_TYPE } from '@tornado-rdk/typography';
import { PRIMARY, QUATERNARY, TERTIARY, makeThemeColor } from '@tornado-rdk/theme';
import { ICON_POSITION } from '../../../utils/templates';
import Icon from '../../../icon/icon.component';
import { Badge } from '../../../badge/badge.component';

export { HEIGHT as INCENTIVE_HEIGHT } from '../../../incentive/incentive.style';

export const DISPLAY_ICONS = true;
export const DISPLAY_TITLE = true;
export const DISPLAY_EXTRA_TITLE = true;
export const DISPLAY_DETAILS = false;

export const IMAGE_MARGIN_BOTTOM = 8;

export const EXTRA_TITLE_FONT_NAME = FONT.OTTAWA_3;

export const EXTRA_TITLE_FONT_TYPE = FONT_TYPE.MAIN;

export const TITLE_FONT_NAME = FONT.MADRID_3;

export const TITLE_FONT_TYPE = FONT_TYPE.MAIN;

export const TITLES_ORDER = ['ExtraTitle', 'Title'];

export const EXTRA_TITLE_LINES = 2;

export const BORDER_COLOR = makeThemeColor(PRIMARY);

export const INNER_BORDER_COLOR = makeThemeColor(TERTIARY);

export const HIGHLIGHT_COLOR = makeThemeColor(QUATERNARY);

export const ICONS = {
  [ICON_POSITION.TOP_LEFT]: 2,
  [ICON_POSITION.TOP_RIGHT]: 4,
  [ICON_POSITION.BOTTOM_RIGHT]: 1,
};

export const ICONS_TYPES = {
  [ICON_POSITION.TOP_LEFT]: Icon,
  [ICON_POSITION.TOP_RIGHT]: Badge,
  [ICON_POSITION.BOTTOM_RIGHT]: Icon,
};

export const templates = {
  CardS: 'CardS',
  CardM: 'CardM',
  CardL: 'CardL',
};

export const ITEMS_BY_BREAKPOINTS = {
  [templates.CardS]: {
    general: {
      [HD]: 6,
      [FULL_HD]: 8,
    },
    search: {
      [HD]: 4,
      [FULL_HD]: 5,
    },
  },
  [templates.CardM]: {
    general: {
      [HD]: 6,
      [FULL_HD]: 6,
    },
    search: {
      [HD]: 3,
      [FULL_HD]: 4,
    },
  },
  [templates.CardL]: {
    general: {
      [HD]: 5,
      [FULL_HD]: 5,
    },
    search: {
      [HD]: 2,
      [FULL_HD]: 3,
    },
  },
};
